import { createStore } from 'jotai';

export const mainStore = createStore();
